import {DefaultPageProps} from "@models/DefaultProps.ts";
import {Paper} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {RecursosPage} from "@components/recurso/pages/RecursosPage.tsx";
import React from "react";
import {RecursoContaContabilLimiteEntry} from "@components/recurso/RecursoContaContabilLimiteEntry.tsx";

interface ContaContabilRecursoLimitePageProps extends DefaultPageProps {
    contaContabilId: number
}

export const ContaContabilRecursoLimitePage: React.FC<ContaContabilRecursoLimitePageProps> = (props) => {
    // const [searchValue, setSearchValue] = useState('');
    // const [applySearch, setApplySearch] = useState('');

    return (
        <DefaultContainer titulo={props.hideHeader ? '' : 'Limites por Conta Contábil'} component={Paper}>
            <RecursosPage disableHeader={props.hideHeader}
                          disableTitle={props.hideHeader}
                          searchType={'LimitesRecurso'}
                          filtros={{idsContaContabil: [props.contaContabilId]}}
                          slotProps={{
                              RecursoItem: {
                                  EndComponent: (r) => <RecursoContaContabilLimiteEntry recursoId={r.id}
                                                                                        contaContabilId={props.contaContabilId}
                                                                                        limiteInitial={r.contaContabilLimites?.find(x => x.contaContabilId == props.contaContabilId)}
                                                                                        onSendLimite={() => {
                                                                                        }}
                                                                                        solicitacoes={r.solicitacoes?.filter(x => x.contaContabilId == props.contaContabilId)}
                                  />
                              }
                          }}/>
        </DefaultContainer>
    );
}